/* ============================================================
   LABBiD 一覧ページの無限スクロール
   作成: 2026-08-26 JST（オファーセッション14）
   置き場所: assets/hb-infinite-scroll.js（★新規ファイル）

   🚫 assets/global.js には1文字も書いていない（テーマの中核なので触らない）
   🚫 snippets/pagination.liquid も触らない（検索結果など他でも使われている）

   ふるまい
     ・下端に近づいたら次のページを取ってきて #product-grid に継ぎ足す
     ・自動で読むのは AUTO_MAX 回まで。その先は「Load more」ボタン
       （7,000件を全部自動で読むとスマホのブラウザが重くなるため）
     ・失敗したら、隠していたページ番号を出し直す（客が行き止まりにならない）
     ・絞り込み・並べ替え（facets.js）でグリッドが差し替わったら付け直す
   ============================================================ */
(function () {
  'use strict';

  var AUTO_MAX = 5; // 自動で読み込む回数。36件 × 5 = 180件ぶん

  function init() {
    var box = document.querySelector('#hb-infinite');
    if (!box || box.dataset.hbReady === '1') return;

    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    // ★ 既定は OFF。テーマ設定が true か、URL に ?hbinf=1 が付いたときだけ動く
    var on = box.dataset.enabled === 'true' || /[?&]hbinf=1/.test(window.location.search);
    if (!on) return;

    var next = box.dataset.nextUrl || '';
    if (!next) return;

    box.dataset.hbReady = '1';

    // ★どこまで読んだかを出すための数字（Liquid から data- で受け取る）
    var totalItems = parseInt(box.dataset.totalItems, 10) || 0;
    var totalPages = parseInt(box.dataset.totalPages, 10) || 0;
    var page = parseInt(box.dataset.currentPage, 10) || 1;
    function nf(n) {
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var track, fill; // ★下で作る。progress() から参照する
    // ★数えるのは商品の <li> だけ。
    //   検索ページでは #product-grid の中にページ番号（.pagination__list の li）も入るので、
    //   単純に querySelectorAll('li') で数えると6件ぶん多く出る（2026-08-26 実測）。
    function shownCount() {
      if (pageLists().length) {
        return document.querySelectorAll('#product-grid [data-hb-list] > li').length;
      }
      var n = 0, k = grid.children.length;
      while (k--) if (grid.children[k].tagName === 'LI') n++;
      return n;
    }
    function progress() {
      var shown = shownCount();
      var pct = totalItems ? Math.min(100, (shown / totalItems) * 100) : 0;
      if (totalItems && fill) {
        // ★1%未満でも「動いた」と分かるように下限を 3px 置く
        fill.style.width = 'max(3px, ' + pct.toFixed(2) + '%)';
        track.setAttribute('aria-valuenow', String(Math.round(pct)));
      }
      var t = 'Showing ' + nf(shown);
      if (totalItems) t += ' of ' + nf(totalItems);
      t += ' products';
      if (totalItems) t += ' (' + (pct < 1 ? pct.toFixed(1) : String(Math.round(pct))) + '%)';
      if (totalPages > 1) t += '  ·  page ' + nf(page) + ' of ' + nf(totalPages);
      return t;
    }

    var nav = box.querySelector('.pagination-wrapper');
    var auto = 0;
    var busy = false;
    var io = null;

    var ui = document.createElement('div');
    ui.className = 'hb-infinite__ui';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button hb-infinite__more';
    btn.textContent = 'Load more';
    btn.hidden = true;

    var status = document.createElement('div');
    status.className = 'hb-infinite__status';
    status.setAttribute('aria-live', 'polite');

    // ★どこまで見たかの帯。★2026-08-26 に一度撤去したが Takahiroさんの判断で戻した。
    //   ⚠️ 7,148件だと 11ページ読んでも 5%。伸びないのは【壊れているのではなく本当に5%】。
    //      分かるように ①塗りの下限を3px ②文字に (5%) を併記 ③帯を細く短くした
    track = document.createElement('div');
    track.className = 'hb-infinite__track';
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    fill = document.createElement('div');
    fill.className = 'hb-infinite__fill';
    track.appendChild(fill);

    ui.appendChild(track);
    ui.appendChild(status);
    ui.appendChild(btn);
    box.insertBefore(ui, box.firstChild);

    // ページ番号は「隠す」だけ。DOM からは消さない（SEO と、失敗したときの保険）
    if (nav) nav.style.display = 'none';

    // 🚨 目印（sentinel）に空の <div> を使ってはいけない。
    //    base.css に `div:empty { display: none }` があり、空だと消えて
    //    IntersectionObserver が一度も発火しない（2026-08-26 に実際に踏んだ）。
    //    ⇒ 中身のある .hb-infinite__ui をそのまま目印にする。
    var sentinel = ui;
    status.textContent = progress();

    function stop(msg) {
      if (io) io.disconnect();
      btn.hidden = true;
      status.textContent = msg || '';
    }

    function giveUp(msg) {
      stop(msg);
      if (nav) nav.style.display = ''; // ★ページ番号を出し直す
    }

    // ★ページの作りが2通りあるので、足し方を分ける
    //   一覧ページ  #product-grid が <ul> そのもの。直下に <li> が並ぶ
    //   検索ページ  #product-grid は <div> で、中に <ul data-hb-list="exact"> と
    //               <ul data-hb-list="partial">（Search results / Related products）がある
    //   ★検索ページは data-hb-list で対応づけて足す。混ざらないようにするため。
    function pageLists() {
      return document.querySelectorAll('#product-grid [data-hb-list]');
    }
    function clean(li) {
      li.classList.remove('scroll-trigger', 'animate--slide-in');
      li.removeAttribute('data-cascade');
      li.style.removeProperty('--animation-order');
      return li;
    }
    function countItems(doc) {
      if (pageLists().length) return doc.querySelectorAll('#product-grid [data-hb-list] > li').length;
      return doc.querySelectorAll('#product-grid > li').length;
    }
    function appendItems(doc) {
      if (!pageLists().length) {
        var items = doc.querySelectorAll('#product-grid > li');
        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(items, function (li) { frag.appendChild(clean(li)); });
        grid.appendChild(frag);
        return;
      }
      var newLists = doc.querySelectorAll('#product-grid [data-hb-list]');
      Array.prototype.forEach.call(newLists, function (nl) {
        var key = nl.getAttribute('data-hb-list');
        var lis = nl.children;
        if (!lis.length) return;
        var target = document.querySelector('#product-grid [data-hb-list="' + key + '"]');
        if (target) {
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(Array.prototype.slice.call(lis), function (li) {
            if (li.tagName === 'LI') frag.appendChild(clean(li));
          });
          target.appendChild(frag);
        } else {
          // ★そのページに無かった側（例: 1ページ目に Related products が無い）は
          //   見出しごと末尾に作る
          var head = nl.previousElementSibling;
          if (head && head.className && head.className.indexOf('title-wrapper') >= 0) {
            grid.appendChild(head.cloneNode(true));
          }
          Array.prototype.forEach.call(nl.querySelectorAll('li'), clean);
          grid.appendChild(nl.cloneNode(true));
        }
      });
    }

    function load() {
      if (busy || !next) return;
      busy = true;
      btn.disabled = true;
      status.textContent = 'Loading…';

      fetch(next, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (!countItems(doc)) {
            next = '';
            stop(progress());
            return;
          }

          appendItems(doc);

          // 🚨 これが無いと、継ぎ足した商品の「Send Offer」を押しても【何も起きない】。
          //    global.js の initProductPopup() は読み込み時に
          //    document.querySelectorAll("[js-send-offer-btn]") へ1つずつ
          //    click を付けているだけなので、あとから足した分には付いていない。
          //    ✅ テーマ側に再実行用の口が用意されている:
          //       global.js 末尾 document.addEventListener("product-popup:init", initProductPopup)
          //    🚫 自前でポップアップの処理を書き写さないこと（本番の値札を触る処理につながる）
          document.dispatchEvent(new Event('product-popup:init'));

          var a = doc.querySelector('.pagination-next a');
          next = a ? a.getAttribute('href') : '';

          page += 1;
          busy = false;
          btn.disabled = false;
          status.textContent = progress();

          if (!next) {
            stop(progress());
            return;
          }

          auto += 1;
          if (auto >= AUTO_MAX) {
            if (io) io.disconnect();
            btn.hidden = false;
          }
        })
        .catch(function () {
          busy = false;
          btn.disabled = false;
          giveUp('Could not load more. Please use the page numbers below.');
        });
    }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) load();
          }
        },
        { rootMargin: '600px 0px' }
      );
      io.observe(sentinel);
    } else {
      btn.hidden = false; // 古いブラウザはボタンだけ
    }

    btn.addEventListener('click', function () {
      btn.hidden = true;
      auto = 0;
      load();
      if (io) {
        io.disconnect();
        io.observe(sentinel);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ★絞り込み・並べ替えは facets.js が #ProductGridContainer の中身を丸ごと差し替える。
  //   差し替わったら付け直さないと、絞り込んだ瞬間に無限スクロールが【無言で】死ぬ。
  var host = document.querySelector('#ProductGridContainer');
  if (host && 'MutationObserver' in window) {
    new MutationObserver(function () {
      init();
    }).observe(host, { childList: true, subtree: true });
  }
})();
